import React, { useEffect, useState } from "react";
import {
  Avatar,
  Card,
  Form,
  Input,
  Layout,
  message,
  Typography,
} from "antd";
import { Content } from "antd/es/layout/layout";
import { Controller, useForm } from "react-hook-form";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import Logo from "@/assets/inspections1.png";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
 import userService from "@/services/user.service";
import InspectionBtn from "@/components/InspectionBtn";
import toast from "react-hot-toast";

const ForgetPassword = () => {
  const { authenticated, role } = useAuth();
  const [userValidated, setUserValidated] = useState(false);
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const [loader, setLoader] = useState(false);


  const onSubmit = async (data) => {
    setLoader(true);
    const payload = {
      email: data?.email?.trim(),
    };
    if (!userValidated) {
      const checkuserExist = await userService.checkuserexist(payload);
       if (checkuserExist?.data?.success) {
        setUserValidated(true);
        localStorage.setItem("useremailvalidated", true)
        toast.success("User Validated");
      } else {
        setUserValidated(false);
        toast.error(checkuserExist.message);
      }
    } else if (userValidated) {
      if (data?.password !== data?.confirmpassword) {
        toast.error("Password is not match");
        return;
      }
      const payload = {
        email: data?.email?.trim(),
        password: data?.password,
        confirmpassword: data?.confirmpassword,
      };

      const forgetpwd = await userService.forgetpassword(payload);
      if (forgetpwd) {
        toast.success("Password created successfully")
        navigate("/login");

      }
   
    }
    setLoader(false);
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "linear-gradient(315deg, #27a770 0%, #efefef 74%)",
      }}
    >
      <Content className="d-flex justify-content-center align-items-center vh-100">
        <Card
          className="mt-0"
          style={{
            width: 450,
            padding: "0px",
            borderRadius: "12px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            backgroundColor: "#FFFFFF",
          }}
        >
          <div className="d-flex flex-column align-items-center">
            <Avatar style={{ width: "120px", height: "80px" }} src={Logo} />
 

          
          </div>
          <Form
            onFinish={handleSubmit(onSubmit)}
            className="p-2 text-start"
            name="login"
            layout="vertical"
            style={{ marginTop: "20px" }}
          >
            <Form.Item
              style={{ marginBottom: "2.5rem" }}
              name="email"
              validateStatus={errors?.email ? "error" : ""}
              help={errors?.email?.message}
            >
              <Controller
                name="email"
                control={control}
                rules={{
                  required: "Email Required",
                }}
                render={({ field }) => (
                  <Input
                    prefix={<UserOutlined className="me-2" />}
                    placeholder="Email"
                    {...field}
                    size="large"
                  />
                )}
              />
            </Form.Item>
            {userValidated ? (
              <>
                <Form.Item
                  style={{ marginBottom: "2.5rem" }}
                  name="password"
                  validateStatus={errors?.password ? "error" : ""}
                  help={errors?.password?.message}
                >
                  <Controller
                    name="password"
                    control={control}
                    rules={{
                      required: "Password Required",
                    }}
                    render={({ field }) => (
                      <Input.Password
                        {...field}
                        prefix={<LockOutlined className="me-2" />}
                        placeholder="Password"
                        size="large"
                      />
                    )}
                  />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "2.5rem" }}
                  name="confirmpassword"
                  validateStatus={errors?.password ? "error" : ""}
                  help={errors?.password?.message}
                >
                  <Controller
                    name="confirmpassword"
                    control={control}
                    rules={{
                      required: "Confirm Password Required",
                    }}
                    render={({ field }) => (
                      <Input.Password
                        {...field}
                        prefix={<LockOutlined className="me-2" />}
                        placeholder="Confirm Password"
                        size="large"
                      />
                    )}
                  />
                </Form.Item>
              </>
            ) : (
              ""
            )}
            <Form.Item>
              <InspectionBtn
                type="primary"
                htmlType="submit"
                size="large"
                block
                disabled={loader}
                style={{ backgroundColor: "#0D9276", border: "none" }}
              >
                {loader ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="ms-2">Loading...</span>
                  </>
                ) : (
                  <Typography.Text className="text-white" strong>
                    Validate User
                   </Typography.Text>
                )}
              </InspectionBtn>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default ForgetPassword;
